module.exports = __webpack_public_path__ + "16a14420cefab6cbcf660f7e8fe4e8f1.png";